import { getDocs, setDoc, deleteDoc, collection, doc } from "firebase/firestore"; 
import { getDb } from "./firebase.js"

export const findAll = async (collectionName) => {
    const doc_refs = await getDocs(collection(getDb(), collectionName))

    const res = []

    doc_refs.forEach(tuning => {
        res.push({
            id: tuning.id, 
            ...tuning.data()
        })
    })

    return res
}

export const updateItem = async (id, item) => {
    await setDoc(doc(getDb(), "item", id), item);
}

export const createPassword = async (id, user) => {
    await setDoc(doc(getDb(), "user", id), user);
}